// src/Softphone.js
import React from 'react';
import useSoftphone from './useSoftphone';
import SoftphoneUI from './SoftphoneUI';

const Softphone = () => {
  const props = useSoftphone();
  return <SoftphoneUI {...props} />;
};

export default Softphone;
